const planner = {
  title: "Planner",
  buttons: {
    newRecurrentTask: "Add New Recurrent Task",
    newOnetimeTask: "Add New Onetime Task",
    cancel: "Cancel",
    gotoTask: "GO TO TASK",
    doneToday: "DONE TODAY",
    done: "DONE",
    delete: "DELETE",
    deleteOnly: "Delete only this task",
    deleteAll: "Delete all tasks",
    deleteThis: "Delete this task"
  },
  labels: {
    search: "Search by name",
    maintenance: "Maintenance",
    reliability: "Reliability",
    repair: "Repair",
    onetimeTask: "Onetime Task",
    onetime: "Onetime",
    recurrentTask: "Recurrent Task",
    recurrent: "Recurrent",
    itHasToBe: "Must be changed every"
  },
  tabs: {
    todo: "TO DO TASK",
    history: "HISTORY"
  },
  messages: {
    notasks: "There are not tasks in history",
    changelog: "Do you want to change the log?"
  }
};
export default planner;
